import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import Link from 'components/Link';
import AdCaller from 'helpers/ads/adCaller';
import s from './ElectionBattle.scss';
import CandidateCard from '../CandidateCard';
import ErrorBoundary from '../../../ErrorBoundary/ErrorBoundary';
import { createSlug } from '../../../../utils/common';

const csValueMapping = {
  3: 'won',
  1: 'leading',
  2: 'trailing',
  4: 'lost',
};

function NextArrow(props) {
  return (
    <span {...props} className={`btn next ${props.className}`}>
      <i />
    </span>
  );
}

function PrevArrow(props) {
  return (
    <span {...props} className={`btn prev ${props.className}`}>
      <i />
    </span>
  );
}
// const defaultCandImg = 89954913;

class ElectionBattle extends React.Component {
  renderbattle = (
    candidate,
    isWapView,
    candidateLinking,
    candidateLinkingAssembly,
    stateName,
    idx,
  ) => {
    if (
      candidateLinking &&
      candidate.sn &&
      candidate.cns_name &&
      candidate.seonm &&
      candidate.c_id
    ) {
      return (
        <Link
          to={`/elections/lok-sabha-elections/${createSlug(
            candidate.sn,
          )}/${createSlug(candidate.cns_name)}/candidateshow/${
            candidate.seonm
          }-${candidate.c_id}`}
          target="_blank"
        >
          <CandidateCard
            csValueMapping={csValueMapping}
            candidate={candidate}
            index={idx}
            isWapView={isWapView}
          />
        </Link>
      );
    } else if (
      candidateLinkingAssembly &&
      stateName &&
      candidate.cns_name &&
      candidate.c_id
    ) {
      return (
        <Link
          to={`/elections/assembly-elections/${createSlug(
            stateName,
          )}/constituency-show/${createSlug(candidate.cns_name)}`}
          target="_blank"
        >
          <CandidateCard
            csValueMapping={csValueMapping}
            candidate={candidate}
            index={idx}
            isWapView={isWapView}
          />
        </Link>
      );
    }
    return (
      <CandidateCard
        csValueMapping={csValueMapping}
        candidate={candidate}
        index={idx}
        isWapView={isWapView}
      />
    );
  };

  render() {
    const {
      isWapView,
      isStarcnd,
      numberOfStates,
      slidesToScroll,
      dots = true,
      infiniteScroll = true,
      blackArrow = false,
      adactive,
      candidateLinking = false,
      candidateLinkingAssembly = false,
      stateName = '',
    } = this.props;
    let slidesToShow = 2;
    if (numberOfStates < 3) {
      slidesToShow = 3;
    }
    if (this.props.slidesToShow) {
      slidesToShow = this.props.slidesToShow;
    }
    const settings = {
      dots: !dots ? dots : true,
      slidesToShow,
      slidesToScroll: slidesToScroll || slidesToShow || 2,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      infinite: !infiniteScroll ? infiniteScroll : true,
    };

    if (
      this.props.starCandidateData &&
      Array.isArray(this.props.starCandidateData) &&
      this.props.starCandidateData.length === 0
    ) {
      return null;
    }

    return (
      <>
        <AdCaller data={{ jname: 'star_candidates_before' }} immediateLoad />

        <div className={`${s.electionBattle}`}>
          <div className={s.battleHeader}>
            {!isStarcnd && (
              <>
                <h4>Star Candidates</h4>
                {adactive && (
                  <AdCaller data={{ jname: 'scPowerby' }} immediateLoad />
                )}
              </>
            )}
          </div>
          <div>
            <div className={s.candidateList}>
              {!isWapView && (
                <div
                  className={`slick_UI smallArrow ${
                    blackArrow ? 'smallArrowBlack' : ''
                  }`}
                >
                  <Slider {...settings}>
                    {this.props.starCandidateData &&
                      Array.isArray(this.props.starCandidateData) &&
                      this.props.starCandidateData.length > 0 &&
                      this.props.starCandidateData.map((candidate, idx) => (
                        <ErrorBoundary>
                          {this.renderbattle(
                            candidate,
                            isWapView,
                            candidateLinking,
                            candidateLinkingAssembly,
                            stateName,
                            idx,
                          )}
                        </ErrorBoundary>
                      ))}
                  </Slider>
                </div>
              )}
              {isWapView &&
                this.props.starCandidateData &&
                Array.isArray(this.props.starCandidateData) &&
                this.props.starCandidateData.length > 0 &&
                this.props.starCandidateData.map((candidate, idx) => (
                  <ErrorBoundary>
                    {this.renderbattle(
                      candidate,
                      isWapView,
                      candidateLinking,
                      candidateLinkingAssembly,
                      stateName,
                      idx,
                    )}
                  </ErrorBoundary>
                ))}
            </div>
          </div>
        </div>
      </>
    );
  }
}

ElectionBattle.propTypes = {
  // isWapView: PropTypes.bool,
  data: PropTypes.shape({
    items: PropTypes.shape({}),
  }),
  starCandidateData: PropTypes.arrayOf(PropTypes.shape({})),
  state: PropTypes.string,
  numberOfStates: PropTypes.number,
};
ElectionBattle.defaultProps = {
  // isWapView: false,
  data: {},
  starCandidateData: [],
  state: '',
  numberOfStates: 3,
};

export default ElectionBattle;
